import { ICountry, ICountryData } from '@/models';

// API Data
export interface IVendorData {
  id: string;

  name: string;
  contact?: string;
  phone?: string;
  currency: string;
  category?: string;
  language?: string;
  email?: string;

  address1?: string;
  address2?: string;
  address3?: string;
  address4?: string;
  city?: string;
  region?: string;
  postal_code?: string;
  country?: string | ICountryData;

  status?: string;
  terms: string;
  terms_description: string;

  manually_created?: boolean;
}

export interface IVendorFieldErrorData {
  id?: string[];

  name?: string[];
  contact?: string[];
  phone?: string[];
  currency?: string[];
  category?: string[];
  language?: string[];
  email?: string[];

  address1?: string[];
  address2?: string[];
  address3?: string[];
  address4?: string[];
  city?: string[];
  region?: string[];
  postal_code?: string[];
  country?: string[];

  status?: string[];
  terms?: string[];
  terms_description?: string[];
}

// Business Logic Interface
export interface IVendor extends IVendorData {
  country?: string | ICountry;
  validate(): boolean;
}

export interface IVendorFieldError extends IVendorFieldErrorData {
  clearErrors(): void;
}

// Constants - Used for validation
export const VENDOR_MAX_ID_LENGTH = 8;
export const VENDOR_MAX_NAME_LENGTH = 128;
export const VENDOR_MAX_CATEGORY_LENGTH = 16;
export const VENDOR_MAX_ADDRESS1_LENGTH = 64;
export const VENDOR_MAX_ADDRESS2_LENGTH = 64;
export const VENDOR_MAX_ADDRESS3_LENGTH = 64;
export const VENDOR_MAX_ADDRESS4_LENGTH = 64;
export const VENDOR_MAX_CITY_LENGTH = 32;
export const VENDOR_MAX_REGION_LENGTH = 16;
export const VENDOR_MAX_POSTAL_CODE_LENGTH = 16;
export const VENDOR_MAX_COUNTRY_LENGTH = 32;
export const VENDOR_CURRENCY_LENGTH = 3;
export const VENDOR_MAX_STATUS_LENGTH = 1;
export const VENDOR_MAX_TERMS_LENGTH = 3;
export const VENDOR_MAX_TERMS_DESCRIPTION_LENGTH = 48;
export const VENDOR_MAX_LANGUAGE_LENGTH = 3;
export const VENDOR_MAX_CONTACT_LENGTH = 48;
export const VENDOR_MAX_PHONE_LENGTH = 32;
